import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUserPreferences } from './store/actions/modernDashboard.actions';
import ModernDashboard from './ModernDashboard';
import UserDashboard from './UserDashboard';
import Dashboard from './Dashboard';

/**
 * Dashboard Router - Routes to appropriate dashboard based on user role and preference
 * - Admin/Instructor users: ModernDashboard (with statistics) or Legacy Dashboard
 * - Regular users: UserDashboard (simplified with world map, featured apps, courses)
 */
const DashboardRouter = (props) => {
	const dispatch = useDispatch();
	const { dashboardType, loading } = useSelector(({ dashboard }) => dashboard.userPreferences);
	const user = useSelector(({ auth }) => auth.user);

	// Check if user is admin or instructor
	const isAdminOrInstructor = () => {
		if (!user || !user.role) return false;
		const roles = Array.isArray(user.role) ? user.role : [user.role];
		return roles.some(r => 
			r === 'admin' || 
			r === 'super-admin' || 
			r === 'instructor'
		);
	};

	useEffect(() => {
		// Fetch user preferences on mount
		dispatch(getUserPreferences());
	}, [dispatch]);

	// Show loading state while fetching preferences
	if (loading && !dashboardType) {
		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				height: '100vh' 
			}}>
				<div>Loading dashboard...</div>
			</div>
		);
	}

	// Regular users (non-admin, non-instructor) always get UserDashboard
	if (!isAdminOrInstructor()) {
		return <UserDashboard {...props} />;
	}

	// Admin/Instructor users: Route based on preference
	if (dashboardType === 'legacy') {
		return <Dashboard {...props} />;
	}

	// Default to modern dashboard for admins/instructors
	return <ModernDashboard {...props} />;
};

export default DashboardRouter;
